import { types } from 'mobx-state-tree';

import CREDIT_BUREAUS from '../definitions/CreditBureaus';
import CreditBureauEnum from '../types/CreditBureauEnum';


const CreditReport = types
    .model('CreditReport', {
        isRequesting: types.maybe(types.boolean),
        creditBureau: types.optional(CreditBureauEnum, CREDIT_BUREAUS.TRANS_UNION),
        attempts: types.optional(types.integer, 0),
        stage: types.maybe(types.string),
        creditReportId: types.maybe(types.string),
    });

export default CreditReport;
